<template>
  <v-app-bar app dense class="top-bar" @contextmenu.prevent>
    <v-app-bar-nav-icon class="ml-2"></v-app-bar-nav-icon>
    <v-toolbar-title class="pl-7">
      <router-link :to="logo"><h1 class="logo"/></router-link>
      <router-link to="/" class="dummy-center-logo">&nbsp;</router-link>
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items>
      <BtnAlert />
      <BtnPreference />
      <BtnUser />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import BtnAlert from './BtnAlert.vue';
import BtnPreference from './BtnPreference.vue';
import BtnUser from './BtnUser.vue';

export default {
  components: {
    BtnAlert,
    BtnPreference,
    BtnUser,
  },
  data: () => ({
    logo: {
      path: '/',
    },
  }),
};
</script>
